module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "sidebar-menu",
    class: [_vm.size === 'sm' ? 'sidebar-menu-sm' : '',
      _vm.theme != 'default' ? 'sidebar-menu-' + _vm.theme : '',
      _vm.curl && _vm.size === 'sm' ? 'sidebar-menu-sm-curl' : '',
      _vm.curl && _vm.size === 'default' ? 'sidebar-menu-curl' : ''
    ],
    style: (_vm.css)
  }, [_vm._l((_vm.surface), function(item, index) {
    return _c('li', {
      staticClass: "menu-item",
      class: [item.alias == _vm.currentItem ? 'menu-item-current' : '',
        item.icon ? 'menu-item-icon' : ''
      ],
      on: {
        "click": function($event) {
          _vm.handleClick(item, index)
        }
      }
    }, [(item.icon) ? _c('i', {
      staticClass: "icon iconfont",
      class: [item.icon ? 'icon-' + item.icon : '']
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.tip) ? _c('span', {
      staticClass: "tip"
    }, [_vm._v(_vm._s(item.tip))]) : _vm._e()])
  }), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6354796f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/sidebar.vue
// module id = 257
// module chunks = 36